import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { getAnyRequirementId, isAnyRequirementRef } from '../../../../../util/requirementRef.util'
import { toArray, toFormValues } from '../../policy_management/utils'
import FormattedPolicyFrame from '../FormattedPolicyFrame'

const propTypes = {
  /**
   * Policy payload (raw policy) object
   */
  rawPolicy: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Form options map
   */
  policyFormOptionsMap: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Inputs to hide from the pretty view
   */
  hiddenInputs: PropTypes.arrayOf(PropTypes.string),
}

// A group or named location requirement is just a name, so a "group:<name>"/"location:<name>"
// value with no explicit optionsMap entry (e.g. a review surface that doesn't build one, unlike
// the template authoring screens) still gets a readable label by stripping the sentinel, rather
// than showing the raw prefixed string.
function ReadOnlyInput(props) {
  const { values, optionsMap } = props

  return toArray(values)?.map((val) => (
    <div key={val} className="text-break-all mb-1">
      {optionsMap?.[val] || (isAnyRequirementRef(val) ? getAnyRequirementId(val) : val)}
    </div>
  ))
}

function PrettyView(props) {
  const { policyFormOptionsMap = {}, rawPolicy = {}, hiddenInputs = [] } = props ?? {}

  const values = useMemo(() => toFormValues(rawPolicy), [rawPolicy])

  return (
    <FormattedPolicyFrame
      renderInput={(input) => <ReadOnlyInput values={values?.[input]} optionsMap={policyFormOptionsMap?.[input]} />}
      displayInput={(input) => !hiddenInputs.includes(input) && !isEmpty(values?.[input])}
    />
  )
}

PrettyView.propTypes = propTypes

export default PrettyView
